/* V3 24-inch tile coverage adapter. Theme-scoped include only; no network interception or shared settings writes. */
(function () {
  'use strict';
  if (!window.Shopify || !Shopify.theme || String(Shopify.theme.id) !== '188587114646') return;
  var catalog = null;
  function readCatalog() {
    var nodes = document.querySelectorAll('script[data-product-json],script[id^="ProductJson-"][type="application/json"]');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var data = JSON.parse(nodes[i].textContent), candidate = data.product || data;
        if (String(candidate.id) === '8663456972950' && candidate.handle === 'interlocking-rubber-tiles-24-inch' && Array.isArray(candidate.variants)) return candidate;
      } catch (ignore) {}
    }
    return null;
  }
  var installed = false;
  function rule(r) {
    if (!r || r.product_type !== 'single' || Number(r.calculation_type) !== 1) return r;
    return Object.assign({}, r, { dimension_per_unit: '4', product_length: '2' });
  }
  function fallback(config, id) {
    if (!config || !Array.isArray(config.variants) || !config.variants.length) return null;
    var product = catalog.variants.find(function (v) { return String(v.id) === String(id); });
    if (!product || product.available !== true || !Number.isFinite(product.price) || product.price < 0) return null;
    var base = config.variants[0];
    if (!base.rule || !base.setting || base.rule.product_type !== 'single' || Number(base.rule.calculation_type) !== 1 || base.rule.unit !== 'ft' || Number(base.rule.is_tiered_pricing) !== 0 || Number(base.rule.enable_bundle_price) !== 0 || base.setting.slug !== 'length-width') return null;
    // Only extend the product-wide configuration when every configured variant agrees.
    var signature = JSON.stringify({rule: base.rule, setting: base.setting});
    if (!config.variants.every(function (v) { return JSON.stringify({rule: v.rule, setting: v.setting}) === signature; })) return null;
    return {shopify_variant_id: 'gid://shopify/ProductVariant/' + product.id, title: product.title, rule: rule(base.rule), setting: JSON.parse(JSON.stringify(base.setting))};
  }
  function setting(v) { return v && v.rule ? Object.assign({}, v, { rule: rule(v.rule) }) : v; }
  var purchaseMode = 'manual', resettingManual = false, invalidRaw = {}, guardedButtons = new Map();
  function mainForm() { return typeof window.getProductAddToCartForm === 'function' ? window.getProductAddToCartForm() : null; }
  function dimensionsValid() {
    var root = document.getElementById('entangle_floor_calculator');
    return root && ['length', 'width'].every(function (name) {
      var input = root.querySelector('input[name="' + name + '"]');
      return input && input.value.trim() !== '' && Number.isFinite(Number(input.value)) && Number(input.value) > 0 && !invalidRaw[name];
    });
  }
  function selectedAvailable() {
    var form = mainForm(), selected = form && form.querySelector('[name="id"]');
    return !!(selected && catalog && catalog.variants.some(function (v) { return String(v.id) === String(selected.value) && v.available === true; }));
  }
  function purchaseInvalid() {
    if (!selectedAvailable()) return true;
    var form = mainForm(), quantity = form && form.querySelector('[name="quantity"]');
    var invalidQuantity = !quantity || !/^\d+$/.test(quantity.value.trim()) || !Number.isSafeInteger(Number(quantity.value)) || Number(quantity.value) < 1;
    if (invalidQuantity) return true;
    return purchaseMode === 'calculator' && !dimensionsValid();
  }
  function guardPurchase() {
    var root = document.getElementById('entangle_floor_calculator'), form = mainForm();
    if (!root || !form) return;
    var blocked = purchaseInvalid();
    var note = document.getElementById('lf-t24-input-guidance');
    if (!note) {
      note = document.createElement('div'); note.id = 'lf-t24-input-guidance'; note.setAttribute('role', 'status');
      var message = document.createElement('p'); message.textContent = 'Enter valid positive room dimensions that produce a whole tile count, or buy by tile count instead.';
      var button = document.createElement('button'); button.type = 'button'; button.textContent = 'Buy by tile count';
      button.addEventListener('click', function () { var qty = form.querySelector('[name="quantity"]'); if (qty) { useManualQuantity(qty); qty.focus(); } });
      note.appendChild(message); note.appendChild(button); root.insertAdjacentElement('afterend', note);
    }
    note.hidden = !blocked;
    note.querySelector('p').textContent = !selectedAvailable() ? 'Select an available tile option before adding to cart.' : purchaseMode === 'calculator' ? 'Enter valid positive room dimensions that produce a whole tile count, or buy by tile count instead.' : 'Enter a whole number of tiles greater than zero, or enter room dimensions.';
    note.querySelector('button').hidden = purchaseMode !== 'calculator' || !selectedAvailable();
    var buttons = Array.from(form.querySelectorAll('button[data-add-to-cart],.lf-calc-cta__b,[data-lf-satc-btn]'));
    document.querySelectorAll('[data-lf-fs-btn]').forEach(function (b) { buttons.push(b); });
    buttons.forEach(function (button) {
      if (blocked) {
        if (!guardedButtons.has(button)) guardedButtons.set(button, {disabled: button.disabled, aria: button.getAttribute('aria-disabled')});
        if (!button.disabled) button.disabled = true;
        if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
      } else if (guardedButtons.has(button)) {
        var before = guardedButtons.get(button); button.disabled = before.disabled || !selectedAvailable();
        if (before.aria === null) button.removeAttribute('aria-disabled'); else button.setAttribute('aria-disabled', before.aria);
        guardedButtons.delete(button);
      }
    });
  }
  function useManualQuantity(qty) {
    if (resettingManual) return;
    var wanted = qty.value, root = document.getElementById('entangle_floor_calculator');
    purchaseMode = 'manual'; invalidRaw = {}; resettingManual = true;
    if (root) root.querySelectorAll('input[name="length"],input[name="width"]').forEach(function (input) { input.value = ''; input.dispatchEvent(new Event('input', {bubbles: true})); });
    resettingManual = false; qty.value = wanted;
    var form = mainForm();
    if (form) form.querySelectorAll('input[name="properties[Width]"],input[name="properties[Length]"]').forEach(function (input) { input.remove(); });
    guardPurchase();
  }
  function installPurchaseGuard(root) {
    var form = mainForm(); if (!form) return;
    form.addEventListener('input', function (event) {
      if (resettingManual) return;
      if (event.target.name === 'quantity') { useManualQuantity(event.target); return; }
      if (root.contains(event.target) && /^(length|width)$/.test(event.target.name)) {
        purchaseMode = 'calculator'; var value = event.target.value;
        invalidRaw[event.target.name] = value !== '' && (!Number.isFinite(Number(value)) || Number(value) <= 0);
        guardPurchase();
      }
    }, true);
    form.addEventListener('change', function (event) {
      if (resettingManual) return;
      if (event.target.name === 'quantity') useManualQuantity(event.target);
      else if (event.target.id === 'entangleExtraCheck') { purchaseMode = 'calculator'; guardPurchase(); }
    }, true);
    form.addEventListener('click', function (event) {
      var stepper = event.target.closest && event.target.closest('.product-page-qty .qty_btn');
      if (stepper && form.contains(stepper)) setTimeout(function () { var qty = form.querySelector('[name="quantity"]'); if (qty) useManualQuantity(qty); }, 0);
    }, true);
    form.addEventListener('submit', function (event) {
      if (purchaseInvalid()) { event.preventDefault(); event.stopImmediatePropagation(); guardPurchase(); var note = document.getElementById('lf-t24-input-guidance'); if (note && typeof note.scrollIntoView === 'function') note.scrollIntoView({block: 'nearest'}); }
    }, true);
    // Theme variant availability updates may write disabled after our input handler.
    // Observe only that attribute, avoiding DOM-content loops from guidance updates.
    var availabilityObserver = new MutationObserver(function () { if (purchaseInvalid()) guardPurchase(); });
    availabilityObserver.observe(form, {attributes: true, subtree: true, attributeFilter: ['disabled']});
    document.querySelectorAll('[data-lf-fs-btn]').forEach(function (button) { availabilityObserver.observe(button, {attributes: true, attributeFilter: ['disabled']}); });
    guardPurchase();
  }
  function labels() {
    var root = document.getElementById('entangle_floor_calculator');
    if (!root) return;
    root.querySelectorAll('input[type="number"][name="length"],input[type="number"][name="width"]').forEach(function (input) { input.step = 'any'; });
    var label = root.querySelector('label[for="extra"]');
    if (label && root.querySelector('#entangleExtraCheck')) label.htmlFor = 'entangleExtraCheck';
    guardPurchase();
  }
  function install() {
    if (installed || typeof window.calculateArea !== 'function' || typeof window.checkVariantId !== 'function' || typeof window.variantSetting !== 'function' || typeof window.SwitchTemplate !== 'function' || !document.getElementById('entangle_floor_calculator')) return false;
    catalog = readCatalog();
    if (!catalog) return false;
    installed = true;
    var getRule = window.checkVariantId, getSetting = window.variantSetting, calculate = window.calculateArea, template = window.SwitchTemplate;
    window.checkVariantId = async function () { var found = await getRule.apply(this, arguments); var derived = found ? null : fallback(arguments[0], arguments[1]); return rule(found || (derived && derived.rule)); };
    window.variantSetting = async function () { return setting(await getSetting.apply(this, arguments) || fallback(arguments[0], arguments[1])); };
    window.calculateArea = function (event, variant, config, price, quantity, mode) { var result = calculate.call(this, event, setting(variant), rule(config), price, quantity, mode); guardPurchase(); return result; };
    window.SwitchTemplate = function (variant, config, price) { purchaseMode = 'manual'; invalidRaw = {}; return template.call(this, setting(variant), rule(config), price); };
    labels();
    installPurchaseGuard(document.getElementById('entangle_floor_calculator'));
    var root = document.getElementById('entangle_floor_calculator');
    if (root) new MutationObserver(labels).observe(root, {childList: true, subtree: true});
    // A cached/fast vendor initialization may already have hidden a missing-rule variant.
    // Re-enter the vendor's own initializer once, only for this empty product widget.
    if (root && root.style.display === 'none' && !root.querySelector('input') && typeof window.EntangleFloorEnableCheck === 'function' && typeof window.getProductAddToCartForm === 'function') {
      var form = window.getProductAddToCartForm(), selected = form && form.querySelector('[name="id"]');
      if (selected && catalog.variants.some(function (v) { return String(v.id) === String(selected.value) && v.available === true; })) {
        Promise.resolve(window.EntangleFloorEnableCheck('/apps/fc-calculator-setting/products/extension?shopify_product_id=gid://shopify/Product/8663456972950', selected.value)).catch(function () { if (window.console) console.warn('V3 tile calculator initialization failed; reload before calculating.'); });
      }
    }
    return true;
  }
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'SCRIPT' && /\/floor-calculator[^/]*\/.*flooring\.min\.js/.test(e.target.src)) install(); }, true);
  if (!install()) document.addEventListener('DOMContentLoaded', install, {once: true});
})();
